"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaxLengthValidator = void 0;
const forms_1 = require("@angular/forms");
// validation function
class MaxLengthValidator {
    constructor() {
        this.validator = this.validatemaxLengthFactory();
    }
    validate(c) {
        return this.validator(c);
    }
    validatemaxLengthFactory() {
        return (c) => {
            let isValid;
            if (c.value !== undefined && c.value !== null && (c.value).toString().length <= this.maxLength) {
                isValid = true;
            }
            if (isValid) {
                return null;
            }
            else {
                return {
                    maxLength: {
                        valid: false
                    }
                };
            }
        };
    }
}
exports.MaxLengthValidator = MaxLengthValidator;
//# sourceMappingURL=maxlength.validator.js.map